// export const API_BASE_URL = 'https://alice-staging.lawaweb.com'; // staging
export const API_BASE_URL = 'https://alice.lawaweb.com'; // production
// refer manifest.json - kr8tif: /fidata or firebase: ''
export const BASE_URL = process.env.PUBLIC_URL;
export const MS_CLIENT_ID = 'ba54ab59-e35a-47e4-b846-b05377cefc9a';
export const DASHBOARD_WITH_FILTERS = [
  'dsdp_brands',
  'wallet_codes',
  'wallet_codes_campaign',
  'subs_monthly_summary',
  'wallet_codes_monthly_summary',
  'subs_financial_metrics',
  'wallet_codes_financial_metrics',
  'wallet_codes_ppoints',
  'general_overview',
  'google_ads_report'
];
export const FOREST_LOGO = 'forest-white';
export const WALLETCODES_LOGO = 'wallet-codes-v-m';
// https://momentjs.com/docs/#/displaying/format/
// https://date-fns.org/v2.25.0/docs/format
export const DATE_FORMAT = 'YYYY-MM-DD';
export const NUMBER_FORMAT = '0[.]0a'; // '0a' -> 1k, '0.0a' -> 1.2m - http://numeraljs.com/#format
export const MIN_DATE = '2006-01-01'; // founded year
export const MAX_LEGEND_LENGTH = 16;
export const DEVICE_PIXEL_RATIO = 2;
export const LIMIT = 10; // used in graphs and multi-dropdowns
export const MIN_LEGEND_COUNT = 3; // min + 1 will show select all checkbox legend
export const LEGEND_POSITION = 'top'; // 'top' or 'bottom'
export const BIG_DATA_TEAM_EMAIL = 'bigdataanalytics@forest-interactive.com';
export const GRAPH_HEIGHT = 200;
export const GRAPH_MIN_HEIGHT = 100;
export const RGBA_COLOR_PALETTE = [
  'rgba(71,150,236,1)',
  'rgba(225,82,65,1)',
  'rgba(66,82,175,1)',
  'rgba(198,52,97,1)',
  'rgba(96,63,176,1)',
  'rgba(131,213,70,1)',
  'rgba(85,188,166,1)',
  'rgba(201,61,32,1)',
  'rgba(246,212,72,1)',
  'rgba(125,143,155,1)',
  'rgba(208,218,89,1)',
  'rgba(240,144,109,1)',
  'rgba(136,111,101,1)',
  'rgba(73,90,99,1)',
  'rgba(33,87,150,1)',
  'rgba(244,181,63,1)',
  'rgba(83,185,209,1)',
  'rgba(214,121,118,1)',
  'rgba(197,150,212,1)',
  'rgba(94,108,186,1)',
  'rgba(187,230,73,1)',
  'rgba(74,53,47,1)',
  'rgba(207,82,243,1)',
  'rgba(139,177,249,1)',
  'rgba(123,184,113,1)',
  'rgba(144,119,199,1)',
  'rgba(237,119,47,1)',
  'rgba(168,46,38,1)',
  'rgba(253,236,112,1)',
  'rgba(145,201,196,1)',
  'rgba(171,140,248,1)',
  'rgba(84,138,247,1)',
  'rgba(227,158,156,1)',
  'rgba(220,135,245,1)',
  'rgba(52,101,246,1)',
  'rgba(124,30,78,1)',
  'rgba(209,216,219,1)',
  'rgba(185,171,165,1)',
  'rgba(159,79,182,1)',
  'rgba(255,251,123,1)',
  'rgba(87,8,191,1)',
  'rgba(198,255,35,1)',
  'rgba(1,99,248,1)',
  'rgba(213,207,0,1)',
  'rgba(255,68,241,1)',
  'rgba(0,172,31,1)',
  'rgba(159,0,158,1)',
  'rgba(1,245,152,1)',
  'rgba(0,44,159,1)',
  'rgba(133,179,0,1)',
  'rgba(200,138,255,1)',
  'rgba(223,179,0,1)',
  'rgba(121,148,255,1)',
  'rgba(233,108,0,1)',
  'rgba(52,248,255,1)',
  'rgba(255,56,53,1)',
  'rgba(86,195,255,1)',
  'rgba(170,141,0,1)',
  'rgba(82,0,87,1)',
  'rgba(233,255,158,1)',
  'rgba(37,0,38,1)',
  'rgba(172,255,213,1)',
  'rgba(255,64,161,1)',
  'rgba(0,143,83,1)',
  'rgba(212,0,100,1)',
  'rgba(71,123,0,1)',
  'rgba(255,144,219,1)',
  'rgba(0,88,39,1)',
  'rgba(255,102,94,1)',
  'rgba(1,152,153,1)',
  'rgba(154,0,81,1)',
  'rgba(249,255,225,1)',
  'rgba(18,0,11,1)',
  'rgba(255,181,80,1)',
  'rgba(0,58,120,1)',
  'rgba(164,98,0,1)',
  'rgba(0,106,144,1)',
  'rgba(108,116,0,1)',
  'rgba(244,193,255,1)',
  'rgba(4,21,0,1)',
  'rgba(227,217,255,1)',
  'rgba(89,18,0,1)',
  'rgba(0,100,87,1)',
  'rgba(255,132,135,1)',
  'rgba(0,43,62,1)',
  'rgba(255,179,202,1)',
  'rgba(75,81,0,1)',
  'rgba(126,0,37,1)'
];
